export const CALCULATIONS_BALANCE_ACCOUNTS = {
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.ACCOUNT': 'Nr. cont',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.ACCOUNT_DESCRIPTION': 'Descriere cont',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.INITIAL_DEBIT': 'Sold initial debit',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.INITIAL_CREDIT': 'Sold initial credit',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.CUMULATIVE_DEBIT': 'Rulaj cumulat debit',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.CUMULATIVE_CREDIT': 'Rulaj cumulat credit',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.FINAL_DEBIT': 'Sold final debit',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.FINAL_CREDIT': 'Sold final credit',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.ACCOUNT_STATUS': 'Status cont',
    'CALCULATIONS.BALANCE_ACCOUNTS.COLUMN.ACCOUNT_USAGE_STATUS': 'Utilizare cont'
};
